// extracted by mini-css-extract-plugin
module.exports = {"QuizList":"QuizList_QuizList__a5VQi"};